import { usePage, useWebsiteSettings } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { getCurrentWebsiteTheme } from 'src/editor/store/website-settings/website-settings-selector'

export const useThemeColor = () => {
  const pageGlobalLinkColor = usePage(pageSelectors.getGlobalLinkColor)

  const pageGlobalTextColor = usePage(pageSelectors.getGlobalTextColor)
  const pageGlobalHeadingColor = usePage(pageSelectors.getGlobalHeadingColor)
  const {
    background: websiteGlobalBackground,
    headerAndFooter: websiteGlobalHeaderAndFooter,
    text: websiteGlobalText,
    buttons: websiteGlobalButtons,
    links: websiteGlobalLinks,
    formFields: websiteGlobalFormFields,
    miscellaneous: websiteGlobalMiscellaneous,
  } = useWebsiteSettings(getCurrentWebsiteTheme) || {}
  return {
    background: websiteGlobalBackground,
    headerAndFooter: websiteGlobalHeaderAndFooter,
    text: {
      ...websiteGlobalText,
      paragraphTextColor:
        pageGlobalTextColor || websiteGlobalText?.paragraphTextColor,
      paragraphBackgroundColor: websiteGlobalText?.paragraphBackgroundColor,
      headingTextColor:
        pageGlobalHeadingColor || websiteGlobalText?.headingTextColor,
      headingBackgroundColor: websiteGlobalText?.headingBackgroundColor,
    },
    buttons: websiteGlobalButtons,
    links: {
      ...websiteGlobalLinks,
      linkTextColor: pageGlobalLinkColor || websiteGlobalLinks?.linkTextColor,
    },
    formFields: websiteGlobalFormFields,
    miscellaneous: websiteGlobalMiscellaneous,
  }
}
